const NOTE_BELL_COLORS = [
  '#ed6c02',
  '#1976d2',
  '#2e7d32',
  '#9c27b0',
  '#d32f2f',
  '#0288d1',
  '#7b1fa2',
  '#c2185b',
  '#00796b',
  '#f57c00'
];

export function getNoteBellColor(userId) {
  if (!userId) return NOTE_BELL_COLORS[0];
  const idx = Math.abs(Number(userId)) % NOTE_BELL_COLORS.length;
  return NOTE_BELL_COLORS[idx];
}
